import { Grid2 as Grid, Typography } from '@mui/material';
import { AuditLogsAccessResponse } from 'api';
import { FlatOption, ProductSelection } from 'pages/AuditLogs/types';
import BusinessUnitSelect from './BusinessUnitSelect/BusinessUnitSelect';
import DateRangeFilter from './DateRangeFilter';
import ProductFilter from './ProductFilter';

export const LogsFilter = ({
  scope,
  handleBusinessEntitySelection,
  handleDateRangeSelection,
  productSelection,
  handleProductSelection,
}: {
  scope: AuditLogsAccessResponse;
  handleBusinessEntitySelection: (selection: FlatOption | null) => void;
  handleDateRangeSelection: (startDate: Date | null, endDate: Date | null) => void;
  productSelection: ProductSelection;
  handleProductSelection: (selection: ProductSelection) => void;
}) => (
  <Grid container spacing={2} sx={{ alignItems: 'center' }}>
    <Grid>
      <Typography variant="body1">Filter By</Typography>
    </Grid>
    <Grid>
      <BusinessUnitSelect
        scope={scope}
        productSelection={productSelection}
        handleBusinessEntitySelection={handleBusinessEntitySelection}
      />
    </Grid>
    <Grid container>
      <DateRangeFilter onDateRangeChange={handleDateRangeSelection} />
    </Grid>
    <Grid>
      <ProductFilter value={productSelection} onChange={handleProductSelection} />
    </Grid>
  </Grid>
);

export default LogsFilter;
